var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "button",
      {
        attrs: {
          type: "button",
          title: _vm.showPaths
            ? _vm.$gettext("Pfad im Verzeichnis ausblenden")
            : _vm.$gettext("Pfad im Verzeichnis anzeigen"),
        },
        on: {
          click: function click($event) {
            $event.preventDefault()
            return _vm.togglePathInfo.apply(null, arguments)
          },
        },
      },
      [
        _c("studip-icon", {
          attrs: {
            shape: "info-circle",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.showPaths
      ? _c(
          "ul",
          {
            staticClass: "studip-tree-course-path",
          },
          _vm._l(_vm.paths, function (path, pindex) {
            return _c(
              "li",
              {
                key: pindex,
              },
              [
                _c(
                  "button",
                  {
                    on: {
                      click: function click($event) {
                        $event.preventDefault()
                        return _vm.openNode(path[path.length - 1].id)
                      },
                    },
                  },
                  [
                    _vm._l(path, function (segment) {
                      return [
                        _vm._v(
                          "\n                    / " +
                            _vm._s(segment.name) +
                            "\n                "
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }